import {
  useEffect,
  useState,
} from 'react';

export default function useSessionStorage(key, initialValue) {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [obj, setObj] = useState(initialValue);

  // When the app starts, check sessionStorage for this value
  useEffect(() => {
    const data = window.sessionStorage?.getItem(key);

    try {
      if (data) {
        const parsed = JSON.parse(data);
        setObj(parsed);
      }
    } finally {
      setHasLoaded(true);
    }
  }, []);

  // Sync changes to this state property to session storage
  useEffect(() => {
    if (!hasLoaded) return;

    window.sessionStorage?.setItem(key, JSON.stringify(obj));
  }, [obj]);

  // Upon broadcast, clear this key from storage
  useEffect(() => {
    const handler = () => {
      window.sessionStorage?.removeItem(key);
    };
    window.addEventListener('dre:clearstorage', handler);

    return () => window.removeEventListener('dre:clearstorage', handler);
  }, []);

  return [obj, setObj, hasLoaded];
}
